import React from 'react';
import {SvgIcon} from '@mui/material';
import type {IconProps} from './types';

export const SwapIcon: React.FC<IconProps> = (props: IconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M19.9999 9.70992L15.2999 14.4199L13.8799 12.9999L17.1799 9.70992L13.8799 6.41992L15.2999 4.99992L19.9999 9.70992Z"
        fill={'currentColor'}
      />
      <path d="M11 10.71V8.70996H18V10.71L11 10.71Z" fill={'currentColor'} />
      <path
        d="M4.00012 15.0567L8.70012 10.3467L10.1201 11.7667L6.82012 15.0567L10.1201 18.3467L8.70012 19.7667L4.00012 15.0567Z"
        fill={'currentColor'}
      />
      <path d="M13 14L13 16L6 16L6 14L13 14Z" fill={'currentColor'} />
    </SvgIcon>
  );
};

// <svg
//   width="24"
//   height="24"
//   viewBox="0 0 24 24"
//   fill="none"
//   xmlns="http://www.w3.org/2000/svg">

// </svg>;
